import CustomToast from "../components/UI/customToast";
import { ADD_BOOKMARK, BOOKMARK_EVENTS, GET_BOOKMARK, TAG_BOOKMARK } from "../reducers/bookmark-reducer";
import bookmarkService from "../services/bookmarkService";
import { dispatchAction } from "../shared/function";

const getBookmarkStart = () => dispatchAction(BOOKMARK_EVENTS.GET_BOOKMARK, GET_BOOKMARK.START);
const getBookmarkSuccess = (data) => dispatchAction(BOOKMARK_EVENTS.GET_BOOKMARK, GET_BOOKMARK.SUCCESS, data);
const getBookmarkError = (error) => dispatchAction(BOOKMARK_EVENTS.GET_BOOKMARK, GET_BOOKMARK.ERROR, error);

export const getBookmark = () => async (dispatch) => {
    dispatch(getBookmarkStart());
    bookmarkService
        .getBookmarksService()
        .then((response) => {
            dispatch(getBookmarkSuccess(response));
        })
        .catch((error) => {
            dispatch(getBookmarkError(error));
        });
};

const addBookmarkStart = () => dispatchAction(BOOKMARK_EVENTS.ADD_BOOKMARK, ADD_BOOKMARK.START);
const addBookmarkSuccess = (data) => dispatchAction(BOOKMARK_EVENTS.ADD_BOOKMARK, ADD_BOOKMARK.SUCCESS, data);
const addBookmarkError = (error) => dispatchAction(BOOKMARK_EVENTS.ADD_BOOKMARK, ADD_BOOKMARK.ERROR, error);

export const addBookmark = (req) => async (dispatch) => {
    dispatch(addBookmarkStart());
    bookmarkService
        .addBookmarksService(req)
        .then((response) => {
            dispatch(addBookmarkSuccess(response));
        })
        .catch((error) => {
            dispatch(addBookmarkError(error));
            CustomToast.error(error.message);
        });
};

const tagBookmarkStart = () => dispatchAction(BOOKMARK_EVENTS.TAG_BOOKMARK, TAG_BOOKMARK.START);
const tagBookmarkSuccess = (data) => dispatchAction(BOOKMARK_EVENTS.TAG_BOOKMARK, TAG_BOOKMARK.SUCCESS, data);
const tagBookmarkError = (error) => dispatchAction(BOOKMARK_EVENTS.TAG_BOOKMARK, TAG_BOOKMARK.ERROR, error);

export const tagBookmark = (req) => async (dispatch) => {
    dispatch(tagBookmarkStart());
    bookmarkService
        .tagBookmarksService(req)
        .then((response) => {
            dispatch(tagBookmarkSuccess(response));
        })
        .catch((error) => {
            dispatch(tagBookmarkError(error));
        });
};
